<template>
  <div class="registration">
    <div class="registration__head">
      <div class="container">
        <div class="registration__inner">
          <div class="registration__search">
            <v-text-field
                placeholder="Поиск участника"
                flat
                solo
                v-model="search"
                hide-details
                prepend-icon="mdi-magnify"
            ></v-text-field>
          </div>
          <div class="registration__registered">
            Зарегистрировано {{registered}} из {{max}}
          </div>
          <div class="registration__filter">
            <button class="registration__button"
                    @click="sort_status"
            >
              <span class="icon">
                <span class="big" :style="status_switcher ? {width: '6px'} : {width: '16px'}"></span>
                <span class="middle"></span>
                <span class="small" :style="status_switcher ? {width: '16px'} : {width: '6px'}"></span>
              </span>
              статус
            </button>
            <button class="registration__button" @click="sort_name">
               <span class="icon">
                <span class="big" :style="name_switcher ? {width: '6px'} : {width: '16px'}"></span>
                <span class="middle"></span>
                <span class="small" :style="name_switcher ? {width: '16px'} : {width: '6px'}"></span>
              </span>
              фамилия
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="registration__body">
      <div class="container">
        <ul class="registration__list">
          <li class="registration__item"
              v-for="(user, index) of users"
              :key="index"
          >
            <div class="registration__box"
                 @click="open_modal(user)"
            >
              <div :class="user.status ? 'registration__cb registration__cb--active' : 'registration__cb'"></div>
              <div class="registration__values">
                <span class="registration__table" v-if="user.tabel">Стол {{ user.tabel }}</span>
                <span class="registration__name">{{ user.name }}</span>
              </div>
            </div>
            <!-- <label for="message" class="registration__text_label"> -->
                    <v-textarea
                        v-model="user.comment"
                        required
                        solo
                        id="message"
                        class="registration__text_textarea"
                        no-resize

                    >
                      <template v-slot:label>
                        Комментарий
                        {{ user.comment }}
                      </template>
                    </v-textarea>
            <button @click="sendMessage(user)" class="btn_red px-3 py-2">Сохранить комментарий</button>
                  <!-- </label> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="registration__modal" v-if="modal">
      <div class="inner">
        <button class="close"
                @click="close_modal(active_user)"
        >
          <svg stroke="inherit" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="icon">
          <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.8337 35V31.6667C33.8337 29.8986 33.1313 28.2029 31.881 26.9526C30.6308 25.7024 28.9351 25 27.167 25H13.8337C12.0655 25 10.3699 25.7024 9.11961 26.9526C7.86937 28.2029 7.16699 29.8986 7.16699 31.6667V35" stroke="#inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.4997 18.3333C24.1816 18.3333 27.1663 15.3486 27.1663 11.6667C27.1663 7.98477 24.1816 5 20.4997 5C16.8178 5 13.833 7.98477 13.833 11.6667C13.833 15.3486 16.8178 18.3333 20.4997 18.3333Z" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="info">
          <span class="registration__name">{{ active_user.name }}</span>
          <span class="registration__table"
                v-if=" active_user.tabel"
          >Стол {{ active_user.tabel }}</span>
        </div>
        <button class="button button-unregister"
                v-if="active_user.status"
                @click="unregister_user(active_user)"
        >Отменить регистрацию</button>
        <button class="button button-register"
                v-else
                @click="register_user(active_user)"
        >Зарегистрировать</button>
      </div>
    </div>
  </div>
</template>

<script>
import {debounce} from "../../debounce";
export default {
  name: "manage-registration",
  props: {
    arusers: Array | String | Number | Boolean | Object,
    max: Array | String | Number | Boolean | Object,
    registered: Array | String | Number | Boolean | Object,
  },
  data () {
    return {
      users: this.arusers,
      messages: {},
      // users: [
      //   {
      //     name: 'Александров Игорь Евгеньевич',
      //     status: true,
      //     tabel: 1
      //   },
      //   {
      //     name: 'Андреев Ярослав Тимофеевич',
      //     status: false,
      //     tabel: false
      //   },
      //   {
      //     name: 'Ильченко Игорь Евгеньевич',
      //     status: true,
      //     tabel: 2
      //   },
      //   {
      //     name: 'Родионов Филипп Константинович',
      //     status: false,
      //     tabel: false
      //   },
      //   {
      //     name: 'Александров Игорь Евгеньевич',
      //     status: true,
      //     tabel: 1
      //   },
      //   {
      //     name: 'Андреев Ярослав Тимофеевич',
      //     status: false,
      //     tabel: false
      //   },
      //   {
      //     name: 'Ильченко Игорь Евгеньевич',
      //     status: true,
      //     tabel: 2
      //   },
      //   {
      //     name: 'Родионов Филипп Константинович',
      //     status: false,
      //     tabel: false
      //   },
      //   {
      //     name: 'Александров Игорь Евгеньевич',
      //     status: true,
      //     tabel: 1
      //   },
      //   {
      //     name: 'Андреев Ярослав Тимофеевич',
      //     status: false,
      //     tabel: false
      //   },
      //   {
      //     name: 'Ильченко Игорь Евгеньевич',
      //     status: true,
      //     tabel: 2
      //   },
      //   {
      //     name: 'Родионов Филипп Константинович',
      //     status: false,
      //     tabel: false
      //   },
      // ],
      filtered_users: [],
      search: '',
      debouncedInput: "", // содержимое инпута после остановки ввода
      modal: false,
      status_switcher: false,
      name_switcher: false,
      active_user: undefined
    }
  },
  methods: {
    open_modal (user) {
      this.modal = true;
      this.active_user = user;
      console.log(this.active_user)
    },
    close_modal (user) {
      this.modal = false;
      this.active_user = undefined;
    },
    register_user (user) {
      let url = '/ajax/reg_corporate.php';
      let comment = user.comment;
      let params = new URLSearchParams();
      params.set('id', user.id);
      params.set('comment', comment);
      fetch(url, {method: 'POST', body: params})
          .then(function (response) {
            return response.text();
          })
          .then((data) => {
            console.log(data);
          });
      user.status = true;
    },
    unregister_user (user) {
      let url = '/ajax/reg_corporate.php';
      let comment = user.comment;
      let params = new URLSearchParams();
      params.set('id', user.id);
      params.set('comment', comment);
      fetch(url, {method: 'POST', body: params})
          .then(function (response) {
            return response.text();
          })
          .then((data) => {
            console.log(data);
          });
      user.status = false;
    },
    sort_status () {
      this.status_switcher = !this.status_switcher;

      if (this.status_switcher) {
        this.users = this.filter_by_status.reverse();
      } else {
        this.users = this.filter_by_status
      }
    },
    sort_name () {
      this.name_switcher = !this.name_switcher;

      if (this.name_switcher) {
        this.users = this.filter_by_name.reverse();
      } else {
        this.users = this.filter_by_name;
      }

    },
    user_search() {
      console.log("Запрос после остановки ввода " + this.debouncedInput);
      let url = '/ajax/search_corporate.php';
      let params = new URLSearchParams();
      params.set('searchQuery', this.debouncedInput);
      fetch(url, {method: 'POST', body: params})
          .then(function (response) {
            return response.json();
          })
          .then((data) => {
            this.users = data;
          });
    },
    sendMessage(user) {
      let comment = user.comment;
      let url = '/ajax/reg_corporate_comment.php';
      let params = new URLSearchParams();
      params.set('id', user.id);
      params.set('comment', comment);
      fetch(url, {method: 'POST', body: params})
          .then(function (response) {
            return response.text();
          })
          .then((data) => {
            console.log(data);
          });
    },
  },
  computed: {
    filter_by_name () {
      return this.users.sort((a, b) => a.name.localeCompare(b.name))
    },
    filter_by_status () {
      const true_status = this.users.filter(user => user.status === true);
      const false_status = this.users.filter(user => user.status === false);

      const result = [];

      true_status.forEach(user => result.push(user));
      false_status.forEach(user => result.push(user));

      return result
    }
  },
  watch: {
    search: debounce(function (newVal) {
      this.debouncedInput = newVal; // свойство debouncedInput - содержимое инпута после остановки ввода
      // if (this.find !== null && this.find.length > 2) { // количество символов после которого делать запрос на поиск
      this.user_search();
      // }
    }, 1000),
  }
}
</script>

<style scoped lang="scss">
@import "../../theme/_variable.scss";

.dark_theme {
   & .registration__search {
      background: #6c6c6d;
      border: 0.5px solid #848a8e;
      border-radius: 10px;
    }
  .registration {
    background: #404040;

    &__head {
      background: #4a4a4a;
    }
    &__button {
      background: #4a4a4a;
      border: 0.5px solid rgba(245, 248, 250, 0.2);
      color: #FFFFFF;

      .icon {
       .big, .middle, .small {
         background: #FFFFFF;
       }
      }
    }
    &__box {
      background: #4a4a4a;
      border: 1px dashed rgba(245, 248, 250, 0.2);
    }
    &__table {
      color: #FFFFFF;
    }
    &__name {
      color: #FFFFFF;
    }
    &__modal {

      & .inner {
        background: #404040;
      }
      & .close {
        stroke: #FFFFFF;
      }
      & .icon {
        stroke: #FFFFFF;
      }
      & .button {
        width: 100%;
        border-radius: 10px;
        padding: 12px 0;
        text-align: center;
        transition: all .3s ease;
        border: 1px solid #FA4237;

        &:hover {
          background-color: rgba(250, 66, 55, .6);
        }

        &-register {
          background-color: #FA4237;
          color: #FFFFFF;
        }
        &-unregister {
          background-color: #404040;
          color: #FFFFFF;
        }
      }

    }
  }
}

.registration {
  background: #FDFDFD;
  border-radius: 15px;
  overflow: hidden;

  .registration__body {
    @media(max-width: 576px) {
      .container {
        padding: 0 9px;
      }
    }

  }


  &__head {
    background: #FFFFFF;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
    border-radius: 0 0 10px 10px;
    padding-bottom: 20px;
  }
  &__search {
    margin-bottom: 10px;
  }
  &__registered {
    margin-bottom: 10px;
    color: #565656;
  }
  &__filter {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 18px;

    @media(max-width: 576px) {
      flex-direction: column;
    }
  }
  &__button {
    background: #F5F8FA;
    border: 0.5px solid #EBF1F4;
    border-radius: 12px;
    padding: 6px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;

    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: #5E6278;

    .icon {
      background: transparent;
      width: 25px;
      height: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;

      .big {
        background: #5E6278;
        height: 2px;
        width: 16px;
        border-radius: 2px;
        transition: all .3s ease;
      }
      .middle {
        background: #5E6278;
        height: 2px;
        width: 12px;
        border-radius: 2px;
        transition: all .3s ease;
      }
      .small {
        background: #5E6278;
        height: 2px;
        width: 6px;
        border-radius: 2px;
        transition: all .3s ease;
      }
    }
  }
  &__body {
    padding: 20px 0;
  }
  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
    list-style: none;

    @media(max-width: 768px) {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
  &__item {
    width: 100%;

    background: rgba(245, 248, 250, 0.3);
    border-radius: 12px;
    padding: 18px 12px;
    gap: 11px;
    cursor: pointer;
    height: 100%;
    overflow: hidden;
  }
  &__box {
    background: rgba(245, 248, 250, 0.3);
    border: 1px dashed #E4E5EC;
    /* border-radius: 12px; */
    padding: 18px 12px;
    display: flex;
    align-items: center;
    gap: 11px;
    cursor: pointer;
    //  height: 100%;
  }
  &__cb {
    width: 24px;
    height: 24px;
    border: 1px solid #FA4237;
    border-radius: 6px;
    background-color: transparent;

    &--active {
      background-color: #FA4237;
    }
  }
  &__values {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2px;
  }
  &__table {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #404040;
  }
  &__name {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 120%;
    color: #404040;
  }
  &__modal {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.69);
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    & .inner {
      width: 100%;
      max-width: 343px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 20px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
    & .close {
      position: absolute;
      top: 20px;
      right: 20px;
      stroke: #404040;
    }
    & .icon {
      stroke: #404040;
    }
    & .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      background-color: transparent !important;
      border-color: transparent !important;
    }
    & .button {
      width: 100%;
      border-radius: 10px;
      padding: 12px 0;
      text-align: center;
      transition: all .3s ease;
      border: 1px solid #FA4237;
      
      &:hover {
        background-color: rgba(250, 66, 55, .6);
      }

      &-register {
        background-color: #FA4237;
        color: #FFFFFF;
      }
      &-unregister {
        background-color: #FFFFFF;
        color: #FA4237;
      }
    }

  }
}

.registration__search {
  background: #F5F8FA;
  border: 0.5px solid #EBF1F4;
  border-radius: 10px;
}


</style>
<style lang="scss">
.registration__search .v-input__slot {
  background: transparent !important;
}
.registration__search .v-input__prepend-outer {
  margin-left: 10px;
}
.registration__box .v-text-field__details {
    display: none;
}
</style>